import { useEffect, useState } from "react";
import { queue } from "../lib/api.ts";
import type { QueueItem } from "../lib/queue.ts";

/** What is still waiting to reach the server, kept current as it drains. */
export function usePendingQueue(): QueueItem[] {
  const [items, setItems] = useState<QueueItem[]>([]);
  useEffect(() => queue.subscribe(setItems), []);
  return items;
}
